export const Footer = () => {
    return(

<section className="bg-white">
    <div className="max-w-screen-xl  mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8">
        <nav className="flex flex-wrap justify-center -mx-5 -my-2">
            <div className="px-5 py-2">
                <a href="#" className="text-base leading-6 text-red-500 hover:text-red-900 no-underline">
                    <i class="fas fa-chevron-up"></i> Ir arriba
                </a>
            </div>
            <div className="px-5 py-2">
                <a className="text-base leading-6 text-red-500 hover:text-red-900 no-underline">
                    Carpinmetalmecanicas@hotmail.com
                </a>
            </div>
            <div className="px-5 py-2">
                <a href="https://wa.link/xwzfle" target="_black" className="text-base leading-6 text-red-500 hover:text-red-900 no-underline">
                    Tel: 311 553 5068
                </a>
            </div>
        </nav>
        <p className="mt-8 text-base leading-6 text-center text-gray-400">
            © 2021 The-best-team
        </p>
    </div>
</section>
    )
}


